<template>
    <v-container fluid>
        <v-form ref="QuestionTypeForm" v-model="valid" lazy-validation>
            <v-card class="elevation-3">
                <div class="card-title">{{ $t('QuestionTypes') }}</div>
                <v-card-text class="mt-4">
                    <v-row>
                        <v-col cols="2">
                            <v-text-field v-if="editItem" outlined dense v-model="QuestionTypeItem.QuestionTypeNameEn" :label="$t('QuestionTypeNameEn')"></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field v-if="editItem" outlined dense v-model="QuestionTypeItem.QuestionTypeNameAr" :label="$t('QuestionTypeNameAr')"></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field v-if="editItem" outlined dense v-model="QuestionTypeItem.IconMdi" :label="$t('QuestionTypeIcon')"></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field v-if="editItem" outlined dense v-model="QuestionTypeItem.Order" :label="$t('Order')"></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-select multiple v-if="editItem" outlined dense v-model="QuestionTypeItem.PatternTypeIds" :items="patterntypes" item-text="nameEn" item-value="id" :label="$t('PatternType')"></v-select>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field v-model="formattedTime" v-if="editItem" outlined dense
                                          :label="$t('AvgTime')"
                                          readonly
                                          @focus="openTimePicker = true"></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-checkbox v-if="editItem" dense v-model="QuestionTypeItem.DisplayInResult" :label="$t('DisplayInResults')"></v-checkbox>
                        </v-col>
                        <v-col cols="2">
                            <v-checkbox v-if="editItem" dense v-model="QuestionTypeItem.DisplayInCharts" :label="$t('DisplayInCharts')"></v-checkbox>
                        </v-col>
                        <v-col cols="2">
                            <v-checkbox class="text-start" v-if="editItem" dense v-model="QuestionTypeItem.DisplayInExcel" :label="$t('DisplayInExcel')"></v-checkbox>
                        </v-col>
                        <v-col cols="6">
                            <v-btn tile color="primary" dense @click="updateQuestionTypeItem" v-if="editItem">{{ $t('Edit') }}</v-btn>
                            <v-btn tile class="ms-3" color="secondary" dense @click="UpdateContactForm" v-if="editItem && QuestionTypeItem.Id==21">{{ $t('updateContactForm') }}</v-btn>
                        </v-col>
                    </v-row>
                    <v-data-table class="mt-3" :headers="headers" dense :items="QuestionTypeItems" :items-per-page="15" v-sortable-data-table
                                  @sorted="saveOrder">
                        <template v-slot:[`item.iconMdi`]="{ item }">
                            <v-icon color="primary">{{ item.iconMdi }}</v-icon>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon color="secondary" @click="editQuestionTypeItem(item)"> mdi-pen</v-icon>
                        </template>
                    </v-data-table>

                </v-card-text>
            </v-card>
            <!-- Time Picker Dialog -->
            <v-dialog v-model="openTimePicker" v-if="openTimePicker" width="400">
                <v-card>
                    <v-card-title>
                        <span class="headline">Select Time</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-text-field v-model.number="hours"
                                              label="Hours"
                                              type="number"
                                              min="0"
                                              outlined></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field v-model.number="minutes"
                                              label="Minutes"
                                              type="number"
                                              min="0"
                                              max="59"
                                              :rules="[value => (value >= 0 && value <= 59) || 'Must be between 0 and 59']"
                                              outlined></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field v-model.number="seconds"
                                              label="Seconds"
                                              type="number"
                                              min="0"
                                              max="59"
                                              :rules="[value => (value >= 0 && value <= 59) || 'Must be between 0 and 59']"
                                              outlined></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeTimePicker">{{$t('OK')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-form>
    </v-container>
</template>
<script>
    import LookupAdminService from '@/services/LookupAdminServices.js'
    import Sortable from 'sortablejs'

    export default {
        components: {
        },
        data() {
            return {
                valid: true,
                patterntypes:[],
                hours: 0,
                minutes: 0,
                seconds: 0,
                openTimePicker: false,
                responseMessage:'',
                editItem: false,
                selectedQuestionTypeItemId: null,
                QuestionTypeItems: [],
                QuestionTypeItem: { QuestionTypeNameEn: '', QuestionTypeNameAr: '', IconMdi: '', Order: '', AvgTime: '00:00:00', PatternTypeIds:null },
                QuestionTypeItemsFull: { Id: '', QuestionTypeNameEn: '', QuestionTypeNameAr: '', IconMdi: '', Order: '', AvgTime: '00:00:00', PatternTypeIds: null },
                headers: [
                    { text: this.$t('Id'), value: 'id', align: 'start', sortable: false },
                    { text: this.$t('QuestionTypeNameEn'), value: 'questionTypeNameEn', align: 'start', sortable: false },
                    { text: this.$t('QuestionTypeNameAr'), value: 'questionTypeNameAr', align: 'start', sortable: false },
                    { text: this.$t('Order'), value: 'order', align: 'start', width: '10%', sortable: false },
                    { text: this.$t('QuestionTypeIcon'), value: 'iconMdi', align: 'start', sortable: false },
                    { text: this.$t('DisplayInResult'), value: 'displayInResult', align: 'start', sortable: false },
                    { text: this.$t('DisplayInCharts'), value: 'displayInCharts', align: 'start', sortable: false },
                    { text: this.$t('DisplayInExcel'), value: 'displayInExcel', align: 'start', sortable: false },
                    { text: this.$t('Actions'), value: 'actions', align: 'start', sortable: false },
                ],
            }
        },
        created() {
            this.loadQuestionTypeItems()
        },
        directives: {
            sortableDataTable: {
                bind(el, binding, vnode) {
                    const options = {
                        animation: 150,
                        onUpdate: function (event) {
                            const items = Array.from(event.to.children)
                                .map((item, index) => ({
                                    id: item.cells[0].innerText,
                                    order: index + 1
                                }))
                            vnode.context.updateOrder(items)
                        }
                    }
                    Sortable.create(el.getElementsByTagName('tbody')[0], options)
                }
            }
        },
        computed: {
            formattedTime() {

                // Format the selected time as hh:mm:ss for display
                return `${(this.hours >= 0 ? this.hours.toString().padStart(2, '0') : '00')}:${(this.minutes >= 0 && this.minutes<=59?this.minutes
                    .toString()
                    .padStart(2, '0') : '00')}:${(this.seconds >= 0 && this.seconds<=59?this.seconds.toString().padStart(2, '0'):'00')}`
            },
        },
        methods: {
            parseTimeSpan(timeSpan) {
                // Assuming timeSpan is in "hh:mm:ss" format
                const parts = timeSpan.split(':')
                this.hours = parseInt(parts[0], 10)
                this.minutes = parseInt(parts[1], 10)
                this.seconds = parseInt(parts[2], 10)
                this.formattedTime = timeSpan // Update the formatted time
            },
            closeTimePicker() {
                if (this.hours >= 0 && this.minutes >= 0 && this.minutes <= 59 && this.seconds >= 0 && this.seconds <= 59) {
                    this.QuestionTypeItem.AvgTime = this.formattedTime
                    this.openTimePicker = false
                }
            },
            saveOrder(event) {
                const movedItem = this.desserts.splice(event.oldIndex, 1)[0]
                this.desserts.splice(event.newIndex, 0, movedItem)
            },
            loadQuestionTypeItems() {
                this.loading = true
                LookupAdminService.listPatternTypeItems().then((res) => {
                    this.patterntypes = res.data
                })
                LookupAdminService.listQuestionTypeItems().then((res) => {
                    console.log('DATA', res.data)
                    this.QuestionTypeItems = res.data
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            editQuestionTypeItem(item) {
                this.editItem = true
                this.QuestionTypeItem.Id = item.id
                this.QuestionTypeItem.QuestionTypeNameEn = item.questionTypeNameEn
                this.QuestionTypeItem.QuestionTypeNameAr = item.questionTypeNameAr
                this.QuestionTypeItem.IconMdi = item.iconMdi
                this.QuestionTypeItem.Order = item.order
                this.selectedQuestionTypeItemId = item.id
                this.QuestionTypeItem.DisplayInResult = item.displayInResult
                this.QuestionTypeItem.DisplayInCharts = item.displayInCharts
                this.QuestionTypeItem.DisplayInExcel = item.displayInExcel
                if(item.avgTime)
                    this.QuestionTypeItem.AvgTime = item.avgTime
                else
                    this.QuestionTypeItem.AvgTime = '00:00:00'

                this.QuestionTypeItem.PatternTypeIds = item.patternTypeIds
                this.parseTimeSpan(item.avgTime)
                this.title = this.$t('Edit')
            },
            updateQuestionTypeItem() {
                if (this.$refs.QuestionTypeForm.validate()) {

                    this.QuestionTypeItemsFull.Id = this.selectedQuestionTypeItemId
                    this.QuestionTypeItemsFull.QuestionTypeNameEn = this.QuestionTypeItem.QuestionTypeNameEn
                    this.QuestionTypeItemsFull.QuestionTypeNameAr = this.QuestionTypeItem.QuestionTypeNameAr
                    this.QuestionTypeItemsFull.IconMdi = this.QuestionTypeItem.IconMdi
                    this.QuestionTypeItemsFull.Order = this.QuestionTypeItem.Order
                    this.QuestionTypeItemsFull.DisplayInResult = this.QuestionTypeItem.DisplayInResult
                    this.QuestionTypeItemsFull.DisplayInCharts = this.QuestionTypeItem.DisplayInCharts
                    this.QuestionTypeItemsFull.DisplayInExcel = this.QuestionTypeItem.DisplayInExcel
                    this.QuestionTypeItemsFull.AvgTime = this.QuestionTypeItem.AvgTime
                    this.QuestionTypeItemsFull.PatternTypeIds = this.QuestionTypeItem.PatternTypeIds
                    LookupAdminService.updateQuestionTypeItems(this.selectedQuestionTypeItemId, this.QuestionTypeItemsFull).then((res) => {
                        this.loadQuestionTypeItems()
                        this.resetItem()
                    }).catch((ex) => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            },
            resetItem() {
                this.editItem = !this.editItem
            },
            updateOrder(items) {
                LookupAdminService.updateQuestionTypeItemsOrder(items).then((res) => {
                    this.loadQuestionTypeItems()
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            UpdateContactForm() {
                this.$router.push('/ContactForm')
            }
        }
    }
</script>